import CircularProgress from "@mui/material/CircularProgress";
import Tooltip from "@mui/material/Tooltip";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

function D365ExistsIcon({ exists }: { exists: boolean | null }) {
    if (exists === null) {
        return <CircularProgress size={12} />;
    }
    return exists ? (
        <Tooltip title="Exists in D365" arrow>
            <CheckCircleIcon sx={{ fontSize: 14, color: "success.main", display: "flex" }} />
        </Tooltip>
    ) : (
        <Tooltip title="Not in D365" arrow>
            <CancelIcon sx={{ fontSize: 14, color: "error.main", display: "flex" }} />
        </Tooltip>
    );
}

export default D365ExistsIcon;
